import { Box, Button, Stack, Typography } from '@mui/material';
import { Dialog } from 'shared/ui/dialog';
import { eventsApi } from 'features/events/api';
import { LoadingBanner } from 'shared/ui/loading-banner';
import { ErrorBanner } from 'shared/ui/error-banner';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { formatDateTime } from 'utils/date-format-helpers';

export const ViewWazzupModal = ({ companyId, day, onClose }: { companyId: number; day: string; onClose: () => void }) => {
  const { data, isFetching, error, refetch } = eventsApi.useGetCompanyWazzupDayQuery({ companyId, day });
  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <Dialog.Title>Переписка Wazzup за {day.split('-').reverse().join('.')}</Dialog.Title>
      <Dialog.CloseButton onClick={onClose} />
      <Dialog.Content>
        {isFetching && <LoadingBanner />}
        {error && <><ErrorBanner errorMessage={extractNestJsErrorMessage(error)} /><Button onClick={() => refetch()}>Повторить</Button></>}
        <Stack spacing={2}>
          {!isFetching && !error && !data?.length && <Typography>Нет сообщений за этот день</Typography>}
          {data?.map(message => (
            <Box key={message.messageId} sx={{ p: 2, borderRadius: 1, bgcolor: message.status === 'inbound' ? 'grey.100' : 'action.selected' }}>
              <Typography variant="subtitle2" sx={{ overflowWrap: 'anywhere' }}>
                {message.status === 'inbound' ? 'Входящее' : 'Исходящее'} · {formatDateTime(message.dateTime)}
              </Typography>
              <Typography variant="caption" sx={{ overflowWrap: 'anywhere' }}>
                {message.chatType} · {message.chatId}
                {(message.authorName || message.contactName) && ` · ${message.status === 'inbound' ? message.contactName || message.chatId : message.authorName || 'Сотрудник'}`}
              </Typography>
              <Typography sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', userSelect: 'text', mt: 1 }}>{message.text}</Typography>
              {message.contentUri && /^https?:\/\//i.test(message.contentUri) && (
                <Button component="a" href={message.contentUri} target="_blank" rel="noopener noreferrer">Открыть вложение</Button>
              )}
            </Box>
          ))}
        </Stack>
      </Dialog.Content>
      <Dialog.Actions><Button onClick={onClose}>Закрыть</Button></Dialog.Actions>
    </Dialog>
  );
};
